<template>
  <div class="center">
    <div class="center-center">
      <!-- 公司logo -->
      <div class="logo">
        <img src="@/assets/images/logo11.png" alt="" />
      </div>
      <!-- 公司logo -->
      <div class="going" @click="$router.push('/')">{{ $t("进入官网") }}</div>
      <!-- 备案信息 -->
      <div class="record">
        <div>舱多保供应链版权所有 版权所有 京ICP备20230419号</div>
      </div>
      <!-- 备案信息 -->
      <div class="register">
        <div class="register-top">{{ $t("找回密码") }}</div>
        <div class="progress">
          <stepone v-if="flag1"></stepone>
          <steptwo v-if="flag2"></steptwo>
          <stepthere v-if="flag3"></stepthere>
        </div>
        <div class="in" v-if="flag1">{{ $t("输入请您的邮箱") }}</div>
        <el-form
          v-if="flag1"
          :model="loginForm"
          :rules="loginRules"
          ref="loginRef"
        >
          <!-- 用户名 -->
          <el-form-item prop="account">
            <el-input
              v-model="loginForm.account"
              :placeholder="$t('请输入注册邮箱')"
            ></el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item class="buttons">
            <el-button
              type="primary"
              class="btn-login co bco"
              @click="loginFn"
              >{{ $t("下一步") }}</el-button
            >
          </el-form-item>
        </el-form>
        <statetwo
          v-if="flag2"
          @btn="changeFlag2"
          :loginForm="loginForm"
        ></statetwo>
        <statethere v-if="flag3"></statethere>
      </div>
    </div>
  </div>
</template>

<script>
import { loginApi } from "@/api";
import { mapMutations, mapState } from "vuex";
import stepone from "./step/stepone.vue";
import steptwo from "./step/steptwo.vue";
import stepthere from "./step/stepthere.vue";
import statetwo from "./state/statetwo.vue";
import statethere from "./state/statethere.vue";
export default {
  data() {
    return {
      flag1: true,
      flag2: false,
      flag3: false,
      // 登录表单的数据对象
      loginForm: {
        lang: null,
        account: "",
      },
      // 登录表单的验证规则对象
      loginRules: {
        account: [
          {
            required: true,
            message: this.$t("请输入注册邮箱"),
            trigger: "blur",
          },
          {
            pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
            message: this.$t("请正确输入邮箱"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["lang"]),
  },
  mounted() {
    this.loginForm.lang = null;
    this.loginForm.account = "";
    this.flag1 = true;
    this.flag2 = false;
    this.flag3 = false;
  },
  methods: {
    ...mapMutations(["changeToken", "changeUserName"]),
    async loginFn() {
      this.$refs.loginRef.validate(async (valid) => {
        if (!valid) return;
        this.loginForm.lang = this.lang;
        // this.flag1 = false;
        // this.flag2 = true;
        // this.$router.push("/forgot?admin=" + this.loginForm.account);
        this.$router.push({
          path: "/find",
          query: {
            lang: this.loginForm.lang,
            account: this.loginForm.account,
          },
        });
      });
    },
    // 更改记住我选中状态
    remember() {
      this.checked = !checked;
    },
    changeFlag2() {
      this.flag2 = false;
      this.flag3 = true;
    },
  },
  components: {
    stepone,
    steptwo,
    stepthere,
    statetwo,
    statethere,
  },
  mounted() {
    // this.init();
    this.loginForm.lang = this.lang;
  },
};
</script>

<style lang="less" scoped>
.center {
  overflow-y: hidden;
}
.center-center {
  overflow-y: hidden;
}
// 顶部logo
.logo {
  width: 286px;
  height: 71px;
  margin-top: 26px;
  margin-left: 64px;
  img {
    width: 100%;
  }
}
// 进入官网按钮
.going {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  right: 171px;
  top: 42px;
  position: absolute;
}
// 进入官网按钮
.center {
  border: 1px solid transparent;
  position: relative;
  height: 100%;
  background: url("../../assets/images/background-clip.png") center no-repeat;
  background-size: cover;
  .register {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
    width: 1000px;
    height: 590px;
    background: #ffffff;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    // padding: 98px 87px 127px 87px;
    padding: 40px 290px 0px 305px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    .register-top {
      display: flex;
      justify-content: center;
      margin-bottom: 57px;
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
    }
    // 更改输入框样式
    ::v-deep .el-input__inner {
      height: 51px !important;
    }
    // 记住我  忘记密码
    .comments {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #808080;
    }
    .buttons {
      margin-top: 65px;
      // display: flex;
      // justify-content: space-between;
      ::v-deep .el-form-item__content {
        display: flex !important;
        justify-content: space-between !important;
      }
    }
    .regBut {
      width: 177px;
      height: 51px;
      background: #ffffff;
      border: 1px solid #3b5ff0;
      border-radius: 4px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #3b5ff0;
    }
    .regBut:hover {
      background: #3b5ff0;
      color: #ffffff;
    }
    .btn-login {
      width: 176px;
      height: 50px;
      background: #3b5ff0;
      border-radius: 4px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      border-color: transparent;
      // margin-left: 36px;
    }
  }
}
// 标志的样式
.signal {
  width: 353px;
  height: 327px;
  position: absolute;
  top: 355px;
  left: 226px;
  img {
    width: 100%;
  }
}
// 标志的样式
// 欢迎
.welcom {
  position: absolute;
  top: 469px;
  left: 607px;
}
.welcom-top {
  width: 431px;
  height: 37px;
  font-size: 38px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 19px;
}
.welcom-bottom {
  width: 281px;
  height: 29px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 300;
  color: #666666;
}
// 欢迎
// 备案信息
.record {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #808080;
  position: absolute;
  bottom: 26px;
  div {
    width: 370px;
  }
}
// 备案信息
// 步骤条
.register-top {
  margin-bottom: 36px;
}
// 步骤条
.progress {
  margin-bottom: 70px;
}
.in {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  margin-bottom: 20px;
}

@media screen and (max-width: 750px) {
  .center .register {
    width: 95%;
    margin: auto;
    padding: 1rem 6rem;
  }
}
</style>
